import {Group as MantineGroup, GroupProps as MantineGroupProps} from "@mantine/core";
import {forwardRef} from "react";

export type GroupProps = MantineGroupProps & {
  // extend props here
}

export const Group = forwardRef<HTMLDivElement, GroupProps>((props, ref) => {
  const {...rest} = props;
  return <MantineGroup ref={ref} {...rest} />;
});
